import { withRouter } from 'react-router-dom';
import { withUser } from 'components/queries/GetUserQuery';

import CancelSpecificBookingItemsCta from './CancelSpecificBookingItemsCta';

export default withRouter(withUser(CancelSpecificBookingItemsCta));
